import { ReactQueryContextProvider } from 'app/agriculture/contexts/RequiredStartupProviders/ReactQueryContext/ReactQueryContextProvider';
import { TokenContextProvider } from 'app/agriculture/contexts/RequiredStartupProviders/TokenContext/TokenContextProvider';
import { Outlet } from 'react-router-dom';
import { AgricultureToast } from 'app/agriculture/AgricultureToast/agriculture_toast';

export function AppOutlet() {
    return (
        <ReactQueryContextProvider>
            <TokenContextProvider>
                <Outlet />
                <AgricultureToast />
            </TokenContextProvider>
        </ReactQueryContextProvider>
    );
}
